/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AmountUnit,
    AmountUnitFromJSON,
    AmountUnitFromJSONTyped,
    AmountUnitToJSON,
    RewardType,
    RewardTypeFromJSON,
    RewardTypeFromJSONTyped,
    RewardTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface RewardResponseObject
 */
export interface RewardResponseObject {
    /**
     * 
     * @type {RewardType}
     * @memberof RewardResponseObject
     */
    rewardType: RewardType;
    /**
     * 
     * @type {AmountUnit}
     * @memberof RewardResponseObject
     */
    amountUnit?: AmountUnit;
    /**
     * 
     * @type {number}
     * @memberof RewardResponseObject
     */
    amount: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof RewardResponseObject
     */
    promoDescriptions?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RewardResponseObject
     */
    nftUri?: string;
    /**
     * 
     * @type {string}
     * @memberof RewardResponseObject
     */
    nftMintDate?: string;
}

export function RewardResponseObjectFromJSON(json: any): RewardResponseObject {
    return RewardResponseObjectFromJSONTyped(json, false);
}

export function RewardResponseObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardResponseObject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rewardType': RewardTypeFromJSON(json['rewardType']),
        'amountUnit': !exists(json, 'amountUnit') ? undefined : AmountUnitFromJSON(json['amountUnit']),
        'amount': json['amount'],
        'promoDescriptions': !exists(json, 'promoDescriptions') ? undefined : json['promoDescriptions'],
        'nftUri': !exists(json, 'nftUri') ? undefined : json['nftUri'],
        'nftMintDate': !exists(json, 'nftMintDate') ? undefined : json['nftMintDate'],
    };
}

export function RewardResponseObjectToJSON(value?: RewardResponseObject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'rewardType': RewardTypeToJSON(value.rewardType),
        'amountUnit': AmountUnitToJSON(value.amountUnit),
        'amount': value.amount,
        'promoDescriptions': value.promoDescriptions,
        'nftUri': value.nftUri,
        'nftMintDate': value.nftMintDate,
    };
}


